import { useEffect, useState } from "react";
import { BudgetService } from "../../_services/budget.service";

export const PERSONNEL_CATEGORY = { key: 7, label: "งบบุคลากร" };

export const useBudgetCategories = () => {
    const [data, setData] = useState({ capitalCategories: [], operatingCategories: [], operatingSubcategories: {} });
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    useEffect(() => {
        let active = true;
        BudgetService.getCategories().then(response => {
            if (!response.data.success) throw new Error("โหลดหมวดงบประมาณไม่สำเร็จ");
            if (active) setData(response.data.data);
        }).catch(() => {
            if (active) setError("ไม่สามารถโหลดหมวดงบประมาณจากฐานข้อมูล กรุณาลองใหม่");
        }).finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, []);
    const allCategories = [...data.capitalCategories, PERSONNEL_CATEGORY, ...data.operatingCategories];
    return {
        subcategoryDetails: data.subcategoryDetails || [],
        CAPITAL_CATEGORIES: data.capitalCategories,
        OPERATING_CATEGORIES: data.operatingCategories,
        loading, error,
        isCapitalCategory: type => data.capitalCategories.some(c => c.key === Number(type)),
        getOperatingSubcategories: type => data.operatingSubcategories[Number(type) === 4 ? 3 : Number(type)] || [],
        getCategoryLabel: type => Number(type) === 4 ? "ค่าใช้สอย (จ้างเหมา)" :
            (allCategories.find(c => c.key === Number(type)) || {}).label || "ไม่ระบุหมวด"
    };
};

export const getItemCategoryKey = item => {
    const type = Number(item.ItemType ?? item.itemType ?? 1);
    const category = item.ItemCategory ?? item.itemCategory;
    // Construction used to be saved with the durable-goods type.
    if (type === 1 && category === "สิ่งก่อสร้าง") return 5;
    if (type === 1 && category === "โครงการ") return 6;
    // Existing outsourcing requests remain visible under operating expenses.
    return type === 4 ? 3 : type;
};
